export const getLatestQuizAnswer = /* GraphQL */ `
  query getLatestQuizAnswer($input: GetLatestQuizAnswerInput!) {
  getLatestQuizAnswer(input: $input) {
      answerId
      attempt
      completePercentage
      completedAt
      id
      ownerId
      quizId
      score
      status
      userId
      workspaceId
  }
}
`;

export const getQuiz = /* GraphQL */ `
  query getQuiz($id: ID!) {
  getQuiz(id: $id) {
      createdAt
      creator
      description
      id
      latestEditor
      meta
      name
      ownerIdAndWsId
      publication_state
      questionsCount
      questionsOrder
      relatedPages
      requiredPassPercentage
      stats
      updatedAt
      version
  }
}
`;

export const getQuizAnswer = /* GraphQL */ `
  query getQuizAnswer($id: ID!) {
  getQuizAnswer(id: $id) {
      answers
      attempt
      completedAt
      duration
      id
      ownerIdAndWsId
      quizAndUserId
      quizId
      score
      status
      userId
  }
}
`;

export const getQuizQuestion = /* GraphQL */ `
  query getQuizQuestion($id: ID!) {
  getQuizQuestion(id: $id) {
      id
      options
      ownerIdAndWsId
      quizId
      text
      version
  }
}
`;

export const getQuizStatistics = /* GraphQL */ `
  query getQuizStatistics($input: GetQuizStatisticsInput!) {
  getQuizStatistics(input: $input) {
      answerId
      attempt
      completePercentage
      completedAt
      id
      ownerId
      quizId
      score
      status
      userId
      workspaceId
  }
}
`;

export const getQuizStats = /* GraphQL */ `
  query getQuizStats($id: ID!) {
  getQuizStats(id: $id) {
      answerId
      attempt
      completePercentage
      completedAt
      id
      ownerIdAndWsId
      quizAndUserId
      quizId
      score
      status
      userId
      userIdAndStatus
  }
}
`;

export const getQuizSummary = /* GraphQL */ `
  query getQuizSummary($quizId: ID!) {
  getQuizSummary(quizId: $quizId) {
      averageScore
      failedCount
      passRate
      passedCount
      totalAttempts
      uniqueUsers
  }
}
`;

export const getUserQuizProgress = /* GraphQL */ `
  query getUserQuizProgress($input: GetUserQuizProgressInput!) {
  getUserQuizProgress(input: $input) {
      latestAttempt {
        answerId
        attempt
        completePercentage
        completedAt
        id
        ownerId
        quizId
        score
        status
        userId
        workspaceId
      }
      quizId
      quizName
      totalAttempts
  }
}
`;

export const listQuizAnswers = /* GraphQL */ `
  query listQuizAnswers($wsId: String!, $quizAndUserId: ModelStringInput!, $sortDirection: ModelSortDirection, $filter: ModelQuizAnswerFilterInput, $limit: Int, $nextToken: String) {
  listQuizAnswers(wsId: $wsId, quizAndUserId: $quizAndUserId, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        answers
        attempt
        completedAt
        duration
        id
        ownerIdAndWsId
        quizAndUserId
        quizId
        score
        status
        userId
      }
      nextToken
  }
}
`;

export const listQuizByState = /* GraphQL */ `
  query listQuizByState($wsId: String!, $publication_state: String!, $filter: ModelQuizFilterInput, $limit: Int, $nextToken: String) {
  listQuizByState(wsId: $wsId, publication_state: $publication_state, filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        createdAt
        creator
        description
        id
        latestEditor
        meta
        name
        ownerIdAndWsId
        publication_state
        questionsCount
        questionsOrder
        relatedPages
        requiredPassPercentage
        stats
        updatedAt
        version
      }
      nextToken
  }
}
`;

export const listQuizQuestions = /* GraphQL */ `
  query listQuizQuestions($wsId: String!, $quizId: ModelIDInput!, $sortDirection: ModelSortDirection, $filter: ModelQuizQuestionFilterInput, $limit: Int, $nextToken: String) {
  listQuizQuestions(wsId: $wsId, quizId: $quizId, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        options
        ownerIdAndWsId
        quizId
        text
        version
      }
      nextToken
  }
}
`;

export const listQuizStats = /* GraphQL */ `
  query listQuizStats($wsId: String!, $quizAndUserId: ModelStringInput!, $sortDirection: ModelSortDirection, $filter: ModelQuizStatsFilterInput, $limit: Int, $nextToken: String) {
  listQuizStats(wsId: $wsId, quizAndUserId: $quizAndUserId, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        answerId
        attempt
        completePercentage
        completedAt
        id
        ownerIdAndWsId
        quizAndUserId
        quizId
        score
        status
        userId
        userIdAndStatus
      }
      nextToken
  }
}
`;

export const listQuizStatsByUser = /* GraphQL */ `
  query listQuizStatsByUser($wsId: String!, $userIdAndStatus: ModelStringInput!, $sortDirection: ModelSortDirection, $filter: ModelQuizStatsFilterInput, $limit: Int, $nextToken: String) {
  listQuizStatsByUser(wsId: $wsId, userIdAndStatus: $userIdAndStatus, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        answerId
        attempt
        completePercentage
        completedAt
        id
        ownerIdAndWsId
        quizAndUserId
        quizId
        score
        status
        userId
        userIdAndStatus
      }
      nextToken
  }
}
`;

export const listQuizzes = /* GraphQL */ `
  query listQuizzes($wsId: String!, $filter: ModelQuizFilterInput, $limit: Int, $nextToken: String) {
  listQuizzes(wsId: $wsId, filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        createdAt
        creator
        description
        id
        latestEditor
        meta
        name
        ownerIdAndWsId
        publication_state
        questionsCount
        questionsOrder
        relatedPages
        requiredPassPercentage
        stats
        updatedAt
        version
      }
      nextToken
  }
}
`;
